import { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { formSubmissionRefs } from "../subjects/formSubmission/refs";

/**
 * The driver reported a fuel card that would not work.
 */
export const fuelCardErrorV1 = tmsEventKind(
  { category: "exception", kind: "fuelCardError", version: 1 },
  {
    refs: formSubmissionRefs,
    facts: {
      fuelError: z.string().nullable(),
    },
  },
);

export const FuelCardErrorV1Schema = fuelCardErrorV1.schema;
export const FuelCardErrorV1FactsSchema = fuelCardErrorV1.facts;

export type FuelCardErrorV1 = z.infer<typeof FuelCardErrorV1Schema>;
export type FuelCardErrorV1Facts = z.infer<typeof FuelCardErrorV1FactsSchema>;

/** Every version of `fuelCardError`, keyed by version. What `catalog.ts` places under `exception`. */
export const fuelCardError = { 1: fuelCardErrorV1 } as const;
